var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPostsActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.04V16.96C4 18.48 4.14 19.56 4.5 20.33C4.5 20.34 4.51002 20.36 4.52002 20.37C4.74002 20.65 5.03 20.79 5.37 20.79C5.9 20.79 6.53998 20.44 7.22998 19.7C8.04998 18.82 9.31003 18.89 10.03 19.85L11.04 21.19C11.44 21.73 11.97 22 12.5 22C13.03 22 13.56 21.73 13.96 21.19L14.98 19.84C15.69 18.89 16.94 18.82 17.76 19.69L17.77 19.7C18.9 20.91 19.9 21.09 20.48 20.37C20.49 20.36 20.5 20.34 20.5 20.33C20.86 19.56 21 18.48 21 16.96V7.04C21 5.52 20.86 4.44 20.5 3.67C20.5 3.66 20.5 3.65 20.48 3.64C19.91 2.91 18.9 3.09 17.77 4.3L17.76 4.31C16.94 5.18 15.69 5.11 14.98 4.16L13.96 2.81C13.56 2.27 13.03 2 12.5 2C11.97 2 11.44 2.27 11.04 2.81L10.03 4.15C9.31003 5.11 8.04998 5.18 7.22998 4.3C6.53998 3.56 5.9 3.21 5.37 3.21C5.03 3.21 4.74002 3.36 4.52002 3.64C4.50002 3.65 4.5 3.66 4.5 3.67C4.14 4.44 4 5.52 4 7.04Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10.25H8",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13.75H10",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostsActive);
export default __webpack_public_path__ + "static/media/posts_active.5efcc6975fe4c150679349e5532704fa.svg";
export { ForwardRef as ReactComponent };